export const useTimezone = () =>
  // eslint-disable-next-line new-cap
  Intl.DateTimeFormat().resolvedOptions().timeZone || 'Australia/Melbourne';
